import * as http from 'axios'
export const getUfs = () => http.get('/uf')



// WEBPACK FOOTER //
// ./src/store/uf/services.js